import { render } from "./OwnerAvatar.vue?vue&type=template&id=cd5f6f1c"
import script from "./OwnerAvatar.vue?vue&type=script&lang=js"
export * from "./OwnerAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__